//Author June Leow
//Date Mar 25th, 2024
import React, {useEffect} from 'react';
import StepCertification from './step-certification';
import StepReportPropertyInfo from './step-report-property-info';
import StepSite from './step-site';
import StepPhoto from './step-photo';
import StepUtilyAncillary from './step-utility-ancillary';

const StepReview  = (props)=>{
  const controller = new AbortController();
  //wrapper function
  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state

  //API call
  //render
  return <div>
    <br/>
    <StepReportPropertyInfo {...props} disabled={true}/>
    <StepSite {...props} disabled={true}/>
    <StepPhoto {...props} disabled={true}/>
    <StepUtilyAncillary {...props} disabled={true}/>
    <StepCertification {...props} disabled={true}/>
  </div>
}


export default StepReview;
